var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"qcw-comment__content redownload",domProps:{"innerHTML":_vm._s(_vm.rendered_text)}}),_c('div',{staticClass:"qcw-comment__note"},[_c('i',[_c('icon',{attrs:{"name":"ic-info"}})],1),_c('small',[_vm._v("Customer will not receive this information")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6a4b87ee","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/CommentRedownload.vue
// module id = jur6
// module chunks = 0